import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import AdminLogin from '../components/AdminLogin';
import AdminDashboard from '../components/AdminDashboard';

const AdminPage = () => {
  const { isAuthenticated, loading } = useAuth();
  const [showDashboard, setShowDashboard] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-void">
        <div className="text-gold text-xl">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated && !showDashboard) {
    return <AdminLogin onSuccess={() => setShowDashboard(true)} />;
  }

  return <AdminDashboard onLogout={() => setShowDashboard(false)} />;
};

export default AdminPage;
